import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { listMastraJobs, patchMastraJob, runMastraJob } from '../api';
import type { MastraPatchBody } from '../types';

export function useMastraJobsList() {
  return useQuery({
    queryKey: ['mastra-jobs', 'list'],
    queryFn: listMastraJobs,
    staleTime: 5 * 60_000,
  });
}

export function usePatchMastraJob() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, body }: { id: string; body: MastraPatchBody }) =>
      patchMastraJob(id, body),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['mastra-jobs', 'list'] });
      toast.success('Workflow updated');
    },
    onError: (error: Error) => {
      toast.error(error.message);
    },
  });
}

export function useRunMastraJob() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => runMastraJob(id),
    onSuccess: (result) => {
      queryClient.invalidateQueries({ queryKey: ['mastra-jobs', 'list'] });
      toast.success(result.status + (result.message ? `: ${result.message}` : ''));
    },
    onError: (error: Error) => {
      toast.error(error.message);
    },
  });
}
